import { useState } from 'react';
import { Modal, Dropdown, Form } from 'react-bootstrap';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import {
  activateLoader,
  deactivateLoader,
  updateEmployeeId,
} from '../../actions/team';
import { teamService } from '../../services';
import { TEAM } from '../../constants';

function EmployeeIdModal({ userId, employeeId }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // Handle employee id
  const handleEmployeeId = (formData) => {
    dispatch(activateLoader());
    const params = {
      userId,
      teamOwnerId: localStorage.getItem('teamOwnerId'),
      employeeId: formData.employeeId,
    };
    teamService
      .update_employee_id(params)
      .then((response) => {
        if (response.data) {
          dispatch(updateEmployeeId(response.data));
          toast.success(TEAM.EMPLOYEE_ID_UPDATE_SUCCESS);
          handleClose();
        }
      })
      .finally(() => {
        dispatch(deactivateLoader());
      });
  };

  return (
    <>
      <Dropdown.Item onClick={handleShow}>
        {employeeId ? 'Update Employee Id' : 'Assign Employee Id'}
      </Dropdown.Item>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        size="md"
        centered
      >
        <Modal.Header>
          <Modal.Title className="m-0">
            {employeeId ? 'Update Employee Id' : 'Assign Employee Id'}
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={handleClose}
          />
        </Modal.Header>
        <Formik
          initialValues={{
            employeeId: employeeId || '',
          }}
          validationSchema={Yup.object({
            employeeId: Yup.string()
              .trim()
              .required('Please enter a valid employee id'),
          })}
          onSubmit={(values) => {
            handleEmployeeId(values);
          }}
        >
          {(formikprops) => (
            <Form
              onSubmit={formikprops.handleSubmit}
              className="needs-validation"
            >
              <section>
                <div className="modal-body">
                  <p className="text-muted text-sm">
                    Assign a unique Employee ID to this team member for tracking
                    and reporting purposes. You can update this ID at any time,
                    but ensure it remains consistent with your organization's
                    records.
                  </p>
                  <div className="form-group">
                    <Field
                      name="employeeId"
                      type="text"
                      className="form-control"
                      as={Form.Control}
                      placeholder="Enter Employee Id"
                    />
                    <ErrorMessage
                      name="employeeId"
                      render={(msg) => (
                        <small className="text-danger">{msg}</small>
                      )}
                    />
                  </div>
                </div>
                <div className="modal-footer d-flex justify-content-between">
                  <button
                    type="button"
                    className="btn btn-link"
                    data-dismiss="modal"
                    onClick={handleClose}
                  >
                    Close
                  </button>
                  <button type="submit" className="btn btn-primary  ml-auto">
                    {employeeId ? 'Update' : 'Assign'}
                  </button>
                </div>
              </section>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
}

EmployeeIdModal.propTypes = {
  userId: PropTypes.string,
  employeeId: PropTypes.string,
};

export default EmployeeIdModal;
